import { resolveTrailingSlashRedirect } from '#shared/utils/resolveTrailingSlashRedirect'

function withCanonicalSlash(path: string): string {
  if (!path.startsWith('/') || path.startsWith('//'))
    return path

  return resolveTrailingSlashRedirect(path) ?? path
}

export function useCmsUrl(url?: string): string | undefined {
  if (!url)
    return url

  try {
    const isAbsolute = url.includes('://') || url.startsWith('mailto:') || url.startsWith('tel:')

    if (!isAbsolute) {
      url = url.startsWith('/') ? url : `/${url}`
    }
    const parsed = new URL(url, window.location.origin)

    // If same domain, return relative path
    if (parsed.hostname === window.location.hostname) {
      return withCanonicalSlash(parsed.pathname + parsed.search + parsed.hash)
    }

    // Otherwise return original (external link)
    return url
  }
  catch {
    return withCanonicalSlash(url)
  }
}
